import { useTranslation } from "react-i18next";
import { Box, Chip, Skeleton } from "@mui/material";

import { GinoCreditsData } from "../../api/services/ginoCredits";
import { PremiumPlanIcon } from "../../assets/icons/gino-icons";
import { useGetCurrentPlan } from "../../../Plans/api/queries/useGetCurrentPlan";
import { formatImgUrl } from "../../../../utils/cardFormating";

import { GinoCreditModal } from "./GinoCreditModal";
import { formatNumberWithK } from "../../../../utils/formatters/numberFormatter";

export const GinoPlans = ({
  ginoCredits,
  open,
  handleOnClickCreditLeft,
  handleCloseCreditLeftModal,
}: {
  ginoCredits: GinoCreditsData;
  open: boolean;
  handleOnClickCreditLeft: () => void;
  handleCloseCreditLeftModal: () => void;
}) => {
  const { t, i18n } = useTranslation("gino", { keyPrefix: "homePage" });
  const { data: currentPlanData } = useGetCurrentPlan();

  const plan = currentPlanData?.data?.data?.plan;
  // Support both structures: new nested (plan.subscriptionType) and old flat (plan)
  const currentPlan = plan?.subscriptionType || plan;

  return (
    <Box sx={styles.plansContainer}>
      {currentPlan && (
        <Chip
          sx={styles.chip(true, "var(--Brand-100, #CCF5C6)")}
          label={currentPlan.title}
          icon={
            currentPlan.imageUrl ? (
              <Box
                component="img"
                src={formatImgUrl(currentPlan.imageUrl)}
                alt={currentPlan.title}
                sx={styles.planImage}
              />
            ) : undefined
          }
          clickable={false}
        />
      )}
      <Chip
        sx={styles.chip(false)}
        label={t("creditLeft", {
          number: formatNumberWithK(ginoCredits.balance < 0 ? 0 : ginoCredits.balance, i18n.language),
        })}
        icon={<PremiumPlanIcon />}
        clickable={true}
        onClick={handleOnClickCreditLeft}
      />
      <GinoCreditModal open={open} onClose={handleCloseCreditLeftModal} ginoCredits={ginoCredits} />
    </Box>
  );
};

export const GinoPlansLoading = () => {
  return (
    <Box sx={styles.plansContainer}>
      {Array.from({ length: 2 }).map((_, index) => (
        <Chip
          key={index}
          sx={styles.chip(index === 0)}
          label={<Skeleton variant="text" width={60} height={20} />}
          icon={<Skeleton variant="circular" width={20} height={20} />}
        />
      ))}
    </Box>
  );
};

const styles = {
  plansContainer: {
    width: { xs: "100%", sm: "fit-content" },
    display: "flex",
    gap: "4px",
    overflow: "hidden",
    padding: "4px",
    borderRadius: "10px",
    border: "1px solid var(--Gray-300, #D0D5DD)",
    background: "var(--Base-White, #FFF)",
  },
  chip: (isActive: boolean, backgroundColor = "var(--Base-White, #FFF)") => ({
    padding: "4px 6px",
    color: isActive ? "var(--Gray-700, #344054)" : "var(--Gray-500, #667085)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    borderRadius: "6px",
    border: isActive ? "1px solid var(--Gray-300, #D0D5DD)" : "none",
    background: backgroundColor,
    "&.MuiChip-root": {
      padding: "0",
    },
    width: { xs: "100%", sm: "fit-content" },
  }),
  planImage: {
    width: "20px",
    height: "20px",
    objectFit: "contain",
  },
};
